import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getOrdersByMechanicURL } from '../utils/api';

const useGetOrdersByMechanic = ({ 
        page = 1,
        limit = 3000,
        mechanicId,  
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingOrders, setGettingOrders ] = useState(false);
    const [ orders, setOrders ] = useState([]);
    const [ totalOrders, setTotalOrders ] = useState(0);
    const [ gettingOrdersReqSuccess, setGettingOrdersReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingOrders) {
            axios.get(getOrdersByMechanicURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                    mechanicId,
                }
            }).then(result => {
                setGettingOrders(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalOrders(result.data.total);
                    }
                    setGettingOrdersReqSuccess(true);
                    setOrders(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingOrdersReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingOrdersReqSuccess(false);
                setGettingOrders(false);
            });
        }
    }, [gettingOrders]);

    return { orders, totalOrders, gettingOrders, setGettingOrders, gettingOrdersReqSuccess };
}

export default useGetOrdersByMechanic;